import { createSelector } from 'reselect'
import { State } from 'index'

const modalSelector = (state: State) => state.modal

export const getBulkStockOpen = createSelector([modalSelector], (state) => state.bulk_stock.open)
export const getBulkStockDate = createSelector([modalSelector], (state) => state.bulk_stock.date)
export const getCautionActionLabel = createSelector([modalSelector], (state) => state.caution.actionLabel)
export const getCautionCancelLabel = createSelector([modalSelector], (state) => state.caution.cancelLabel)
export const getCautionDescription = createSelector([modalSelector], (state) => state.caution.description)
export const getCautionOnClickAction = createSelector([modalSelector], (state) => state.caution.onClickAction)
export const getCautionOpen = createSelector([modalSelector], (state) => state.caution.open)
export const getCautionTitle = createSelector([modalSelector], (state) => state.caution.title)
export const getCautionActionType = createSelector([modalSelector], (state) => state.caution.actionType)
export const getConfirmModalOpen = createSelector([modalSelector], (state) => state.confirm.open)
export const getModalContent = createSelector([modalSelector], (state) => state.content)
export const getModalDescription = createSelector([modalSelector], (state) => state.description)
export const getModalEdited = createSelector([modalSelector], (state) => state.edited)
export const getModalError = createSelector([modalSelector], (state) => state.error)
export const getModalOpen = createSelector([modalSelector], (state) => state.open)
export const getModalTitle = createSelector([modalSelector], (state) => state.title)
export const getStaffOpen = createSelector([modalSelector], (state) => state.staff.open)
export const getStaff = createSelector([modalSelector], (state) => state.staff.staff)
export const getStockDate = createSelector([modalSelector], (state) => state.stock.date)
export const getStockEdited = createSelector([modalSelector], (state) => state.stock.edited)
export const getStockOpen = createSelector([modalSelector], (state) => state.stock.open)
export const getStoreSwitchOpen = createSelector([modalSelector], (state) => state.store.open)
export const getStoreSwitchName = createSelector([modalSelector], (state) => state.store.store_name)
export const getShopSwitchRef = createSelector([modalSelector], (state) => state.store.shop_ref)
export const getStoreSwitchRef = createSelector([modalSelector], (state) => state.store.store_ref)
export const getStoreManufacturerRef = createSelector([modalSelector], (state) => state.store.manufacturer_ref)
